import { bl_inv_bin_hdr_RowClass, bl_inv_bin_line_RowClass, bl_inv_bin_lock_RowClass, bl_inv_bin_lock_RowInterface } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';
import * as fromDatatype from '../../../datatype-library/index';

export class BinLockCustomContainer extends BaseContainerModel {
  bl_inv_bin_lock: bl_inv_bin_lock_RowInterface = new bl_inv_bin_lock_RowClass();
  bin_hdr: bl_inv_bin_hdr_RowClass = new bl_inv_bin_hdr_RowClass();
  bin_line: bl_inv_bin_line_RowClass = new bl_inv_bin_line_RowClass();
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
}